import { render, staticRenderFns } from "./Agregar_Editar_Usuario.vue?vue&type=template&id=2c23a23e&scoped=true"
import script from "./Agregar_Editar_Usuario.vue?vue&type=script&lang=js"
export * from "./Agregar_Editar_Usuario.vue?vue&type=script&lang=js"
import style0 from "./Agregar_Editar_Usuario.vue?vue&type=style&index=0&id=2c23a23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c23a23e",
  null
  
)

export default component.exports